var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.43 31.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "underline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.53,0h7.79v14.67c0,2.43,1.25,4.37,4.41,4.37s4.37-1.94,4.37-4.37V0h7.79v14.89c0,6.31-3.61,10.9-12.16,10.9S2.53,21.2,2.53,14.93V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.93,31.02H1.5c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h26.43c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/Underline.80c65db5a7f7f07e1bb1efc83b816018.svg";
export { ForwardRef as ReactComponent };